import {
    SpendingReport_Tab1,
    SpendingReport_Tab2,
    SpendingReport_Tab3,
    SpendingReport_Tab4,
    SpendingReport_AggTab,
} from "../interface/MyInterfaces";
import { aggUniversityAlternateName_AnotherCase, aggUniversityAlternateName_LowerCase, aggUniversityLongName_SpendingReport, numberWithCommas, formatFiscalYear, getYearRangeLabel, getTop4Agency, getOrdinal, padWithTwoLeadingZeros, padWithFourLeadingZeros, trimLeadingZero, billionNumberFormat, billionNumberFormatDown, numberFormat, numberFormatDown, getYearRangeLabel_Lowercase, isAgg } from '../components/Common/Helpers';

export function setHeader(common, agg_report_uni_count, bench_schools, agg_schools, agg_school_names, agg_description, methodology_text, title, change_description, agg_universities_list) {
    const agg = isAgg(common.display_id);//check if it's aggregate report
    const stateLevel = common.state_fips;
    //const name = agg && stateLevel ? `${common.state_name} Universities` : common.university;
    const name = common.university;
    return dispatch => {
        const header = `${common.capitalizedType} Research Funding:`;
        //let sub_header = `A Detailed Analysis of Research Expenditures at ${common.university}`;
        let sub_header = `A Detailed Analysis of Research Expenditures at ${name}`
        if (title != null && title != "" && title == "Spending by Big 10 Universities") {
            sub_header = title;
        }
        let report_text = agg ? `This report characterizes ${common.reportType} research spending at ${(common.university)}. This report is based on actual financial and payroll records submitted to IRIS for fiscal years ${getYearRangeLabel_Lowercase(common.startYear_endYear)}. For a list of the universities included in this report, see the Methodology section.` :
            `This report characterizes ${common.reportType} research spending at ${common.university} based on actual financial and payroll records for ${getYearRangeLabel_Lowercase(common.startYear_endYear)} submitted to IRIS.`;

        const chart1_main_title = `Individuals Employed by ${common.capitalizedType} Research Funding`;
        const chart2_main_title = "Organization of the Scientific Workforce";
        const chart3_main_title = "National Distribution of Research-Related Expenditures";
        const chart4_main_title = "Regional Distribution of Research-Related Expenditures";

        let chart1_chart_title = `Counts of all individuals paid on ${common.university}'s research awards by occupational category (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})`;

        let chart2_chart_title = `Employment patterns of ${common.reportType} research awards to ${common.university} by sponsor (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})`;

        let chart3_chart_title = `Total vendor and subaward expenditures on ${common.reportType} research awards to ${common.university} by county (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})*`;

        const chart1_chart_title_agg = `Counts of all individuals paid on ${common.university}'s research awards by occupational category (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})`;
        const chart2_chart_title_agg = `Employment patterns of ${common.reportType} research awards to ${common.university} by sponsor (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))}) `;
        
        if (agg) {
            //common.title_with_research = true;
            report_text = `This report characterizes ${(common.title_with_research) ? " " : common.reportType + " research expenditures at "} ${aggUniversityLongName_SpendingReport(common.university)} based on financial and payroll records submitted to IRIS for ${getYearRangeLabel_Lowercase(common.startYear_endYear)}.${common.university == "CPUPC/IRIS Universities" || common.university == "IRIS Universities" ? " For a list of the universities included in this report, see the Methodology section." : ""}`;

            if (common.university == "CPUPC/IRIS Universities")
                report_text = report_text.replace("For a list of the universities included in this report, see the Methodology section.", "CPUPC comprises Texas public general academic universities, system offices, health-related institutions, and the three two-year state colleges in the Houston area. CPUPC universities represented in this report are: Texas A&M University, Texas State University, Texas Tech University, Texas Tech University Health  Sciences Center, The University of Texas at Arlington, University of Texas - Austin, University of Texas at Dallas, University of Texas at San Antonio.");
            
            // report is Big 10 aggregate
            if (common.university == "IRIS/Big 10 Universities" && agg_universities_list){
                report_text += " The following universities are represented in this report:" + agg_universities_list;
            }
            
            //console.log(common.title_with_research);
            chart1_chart_title = `Counts of total individuals on ${aggUniversityAlternateName_LowerCase(common.university)}${(common.title_with_research) ? "" : " " + common.reportType + " research awards"}, broken down by occupational category (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})`;

            chart2_chart_title = `Employment patterns of ${(common.title_with_research) ? "" : common.reportType + " research awards from"} ${aggUniversityAlternateName_AnotherCase(common.university)} for ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))}`;

            chart3_chart_title = `Total vendor and subaward expenditures on ${(common.title_with_research) ? "" : common.reportType + " research awards from "} ${aggUniversityAlternateName_AnotherCase(common.university).replace(" at "," from ")} (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})*`;
        }
        let text: SpendingReport_Tab1 = {
            header: header, sub_header: sub_header, report_text: report_text,
            chart1_main_title: chart1_main_title,
            chart2_main_title: chart2_main_title,
            chart3_main_title: chart3_main_title,
            chart4_main_title: chart4_main_title,
            chart1_chart_title: chart1_chart_title,
            //chart1_chart_title_agg: chart1_chart_title_agg,

            chart2_chart_title: chart2_chart_title,
            //chart2_chart_title_agg: chart2_chart_title_agg,

            chart3_chart_title: chart3_chart_title,
            //chart4_chart_title: chart4_chart_title,
        };
        let text2: SpendingReport_Tab2 = {
            header: header,
            sub_header: sub_header,

            chart1_chart_title: `Total vendor and subaward expenditures on ${(common.title_with_research) ? "" : common.reportType + " research awards from"} ${aggUniversityAlternateName_AnotherCase(common.university).replace(" at ", " from ")} by congressional district (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})`,
            chart2_chart_title: `Vendor and subaward expenditures on ${common.capitalizedType.toLowerCase()} research awards to ${aggUniversityAlternateName_AnotherCase(name)} by ${common.satate_name == undefined ? "" : common.satate_name} congressional district (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})*`
            
        };

        let text3: SpendingReport_Tab3 = {
            header: header,
            sub_header: `${common.university.replace('the ', '')} UMETRICS Data Benchmarking Report`,
            university: `${common.university.replace('the', '')}`,
            Initial_the_university: common.university,
            bench_year: common.bench_year,
            bench_schools: bench_schools
        };

        let text4: SpendingReport_Tab4 = {
            header: header,
            rangeLabel: `${getYearRangeLabel(common.startYear_endYear)}`,
            methodology_text: methodology_text,
            change_description: change_description
        };
        let agg_text: SpendingReport_AggTab = {
            header: header,
            sub_header: `Aggregate Report of Research Expenditures from ${agg_schools.length} IRIS Member Universities (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})`,
            report_text: `<p>This report documents FY ${common.bench_year} ${common.reportType} research funding and expenditures at ${agg_schools.length} IRIS member universities: ${agg_school_names}.</p>`,
            chart1_main_title: chart1_main_title,
            chart1_chart_title: chart1_chart_title_agg,
            chart2_chart_title: chart2_chart_title_agg
        };
        //set report text
        dispatch({ type: "SPENDING_TAB1_HEADER", payload: text });
        dispatch({ type: "SPENDING_TAB2_HEADER", payload: text2 });
        dispatch({ type: "SPENDING_TAB3_HEADER", payload: text3 });
        dispatch({ type: "SPENDING_TAB4_HEADER", payload: text4 });
        dispatch({ type: "SPENDING_AGGTAB_HEADER", payload: agg_text });

    }
}

function formatEmployeeAgencyChart(common, the_data) {
    //var the_data = this.props.SpendingEmployeeAgencyChart;
    var data = [];
    var the_occs = [], unique_occs = [];
    if (the_data !== undefined) {
        var agencies = [...new Set(the_data.map((item) => { return item["agy"] + " (" + numberWithCommas(item["total"]) + ")"; }))];
        agencies.map((agy) => {
            var the_agy = { agy: agy };
            let total: number = 0;
            const occSet = new Set([]); //prevent add same occ multiple times which may cause total=times*100
            var titles = the_data.map((item) => {
                if ((item["agy"] + " (" + numberWithCommas(item["total"]) + ")") == agy && !occSet.has(item["occ"])) {
                    let percentage: number = +(item["percentage"] * 100);
                    total += parseFloat(percentage.toFixed(1));
                    the_agy[item["occ"]] = parseFloat(percentage.toFixed(1));

                    the_occs.push(item["occ"]); //keep track of ocss found in data
                    occSet.add(item["occ"]);
                }
            });
            //adjust last items value so total is exactly 100
            //var lastItem = Object.keys(the_agy)[Object.keys(the_agy).length - 1];
            //the_agy[lastItem] -= (total - 100);
            data.push(the_agy);
        });
    }
    var top_8 = data.slice(0, 8);
    //For any given agy we need to make sure all "occ" keys are present in the array or else it won't draw on chart.
    unique_occs = [...new Set(the_occs)];
    top_8.forEach(function (item) {
        unique_occs.forEach(function (occ) {
            if (!(occ in item)) {
                item[occ] = 0;
            }
        })
    });
    //return data;
    if (data !== undefined) {
        //add Post Graduate Researcher if does not exist.

        var new_data = [];

        top_8.map(item => {
            //don't do this for UVA
            if (common.display_id != '23790') {
                if (!item.hasOwnProperty("Post Graduate Researcher")) {
                    item["Post Graduate Researcher"] = 0;
                }
            }
            new_data.push(item);
        });
        return new_data;
    }
    return top_8;
}

function formatEmployeeChart(the_data) {
    var formatted_data = [];
    var years = [], unique_years = [];
    if (the_data !== undefined) {
        the_data.forEach(function (item) {
            var the_occ = item["occupational_bucket"];//.replace("Post Graduate Researcher", "PGR").replace("Research Analyst", "RA");
            var job_obj = { title: item["job_title"], value: item["count"] };

            var year = item["year"];
            var year_detail = item["year"] + "detail";
            years.push(year); //keep track of years found in data
            var the_index = formatted_data.findIndex(x => x.occ == the_occ);
            if (the_index === -1) {
                var obj = {
                    occ: the_occ,
                    [year]: item["total"],
                    [year_detail]: [job_obj]
                }
                formatted_data.push(obj);
            }
            else {
                //year not already added..
                if (!(year in formatted_data[the_index])) {
                    formatted_data[the_index][year] = item["total"]
                    formatted_data[the_index][year_detail] = [job_obj]
                }
                else {
                    // add only job details
                    formatted_data[the_index][year_detail].push(job_obj);
                }

            }
        });

        //For any given occupation we need to make sure all "year" keys are present in the array or else it won't draw on chart.
        unique_years = [...new Set(years)];

        formatted_data.forEach(function (item) {
            unique_years.forEach(function (year) {
                if (!(year in item)) {
                    var year_detail = year + "detail";
                    item[year] = 0;
                    item[year_detail] = [];
                }
            })
        });
    }
    return formatted_data;
}
export function getYears(data) {
    var years = [];
    if (data !== undefined) {
        const fill = ["#c1d7d8", "#8884d8", "#82ca9d", "#5cbae6", "#b6d957", "#fac364", "#8cd3ff", "#d998cb", "#f2d249", "#93b9c6", "#ccc5a8", "#52bacc", "#dbdb46", "#98aafb", "#cdfad0", "#00a10b", "#6124c9"];
        var yeardetails = Object.keys(data).filter(function (obj) { return obj.indexOf("detail") !== -1; });

        yeardetails = yeardetails.sort((a, b) => {
            if (+(a.slice(0, 4)) > +(b.slice(0, 4))) return 1;
            if (+(a.slice(0, 4)) < +(b.slice(0, 4))) return -1;
            return 0;
        })

        years = yeardetails.map(function (str, i) {
            return { year: +str.substring(0, 4), fill: fill[i] };
        });
    }
    return years;
}
export function setEmployeeAgencyChartText(json, common, agg_schools, agg) {
    return dispatch => {
        var chartData = json;
        var data = formatEmployeeAgencyChart(common, json);
        if (agg==0)
            dispatch({ type: "SPENDING_TAB1_CHART2_DATA", payload: data });
        else
            dispatch({ type: "SPENDING_AGGTAB_CHART2_DATA", payload: data });

        var agy_totals_postgrad = [], agy_totals_students = [], agy_totals_faculties = [];
        if (chartData !== undefined) {
            agy_totals_postgrad = chartData.filter((item) => {
                return (item.occ == "Post Graduate Researcher");
            });
            agy_totals_students = chartData.filter((item) => {
                return (item.occ == "Graduate Student" || item.occ == "Undergraduate" || item.occ == "Other Student");
            });
            agy_totals_faculties = chartData.filter((item) => {
                return (item.occ == "Faculty");
            });
        }


        let firstParagraph, secondParagraph;
        const reportType = common.reportType;
        if (common.display_id == '23790') {
            //UVA
            const hhsFaculty = agy_totals_faculties.filter(item => item.agy === 'HHS');
            const othFaculty = agy_totals_faculties.filter(item => item.agy === 'OTH FED');
            const nsfFaculty = agy_totals_faculties.filter(item => item.agy === 'NSF');
            const dodFaculty = agy_totals_faculties.filter(item => item.agy === 'DOD');

            firstParagraph = `During ${(agg == 0) ? formatFiscalYear(getYearRangeLabel(common.startYear_endYear)) : "FY " + common.bench_year}, students at ${(agg == 0) ? (common.university) : "these agg_schools.length IRIS member universities"} constituted 0.0% of the research workforce supported by NSF awards and 0.0% of employees supported by awards from NIH.`;

            secondParagraph = `Faculty comprised ${(hhsFaculty[0].percentage * 100).toFixed(1)}% (${hhsFaculty[0].count}), ${(othFaculty[0].percentage * 100).toFixed(1)}% (${othFaculty[0].count}), ${(nsfFaculty[0].percentage * 100).toFixed(1)}% (${nsfFaculty[0].count}), and ${(dodFaculty[0].percentage * 100).toFixed(1)}% (${dodFaculty[0].count}) of the employees on awards from HHS, OTH FED, NSF, and DOD, respectively.`;

        } else {
            const [nsfGrad, nsfUndergrad, nsfOther] = agy_totals_students.filter(item => { return (item.agy == "NSF"); });
            const [nihGrad, nihUndergrad, nihOther] = agy_totals_students.filter(item => { return (item.agy == "NIH"); });
            const nsfGradPercentage = nsfGrad ? nsfGrad.percentage*100 : 0;
            const nsfUndergradPercentage = nsfUndergrad ? nsfUndergrad.percentage * 100 : 0;
            const nsfOtherPercentage = nsfOther ? nsfOther.percentage * 100 : 0;
            const nihGradPercentage = nihGrad ? nihGrad.percentage*100 : 0;
            const nihUndergradPercentage = nihUndergrad ? nihUndergrad.percentage*100 : 0;
            const nihOtherPercentage = nihOther ? nihOther.percentage * 100 : 0;

            const nsfStudentsPercentage = (Math.round((Math.round(nsfGradPercentage * 10) / 10 + Math.round(nsfUndergradPercentage * 10) / 10 + Math.round(nsfOtherPercentage * 10) / 10) * 100) / 100).toString();
            const nihStudentsPercentage = (Math.round((Math.round(nihGradPercentage * 10) / 10 + Math.round(nihUndergradPercentage * 10) / 10 + Math.round(nihOtherPercentage * 10) / 10) * 100) / 100).toString();

            firstParagraph = `During ${(agg == 0) ? formatFiscalYear(getYearRangeLabel(common.startYear_endYear)) : "FY " + common.bench_year}, students ${common.display_id == "999005" ? "on" : "at"} ${(agg == 0) ? aggUniversityAlternateName_AnotherCase(common.university) : `these ${agg_schools.length} IRIS member universities`} constituted ${(nsfStudentsPercentage == "0.0") ? "" : nsfStudentsPercentage + "% of the research workforce supported by NSF awards and "}${nihStudentsPercentage}% of employees supported by awards from NIH.`

            const [{ agy: firstAgency }, { agy: secondAgency }, { agy: thirdAgency }, { agy: fourthAgency }] = getTop4Agency(data);

            if (agy_totals_postgrad[0]) {
                var firstCountVar = agy_totals_postgrad.filter(x => x.agy == firstAgency.split("(")[0].trim() && x.occ == "Post Graduate Researcher")[0];
                var firstCount = (firstCountVar !== undefined) ? firstCountVar.count : 0;
                var secondCountVar = agy_totals_postgrad.filter(x => x.agy == secondAgency.split("(")[0].trim() && x.occ == "Post Graduate Researcher")[0];
                var secondCount = (secondCountVar !== undefined) ? secondCountVar.count : 0;
                var thirdCountVar = agy_totals_postgrad.filter(x => x.agy == thirdAgency.split("(")[0].trim() && x.occ == "Post Graduate Researcher")[0];
                var thirdCount = (thirdCountVar !== undefined) ? thirdCountVar.count : 0;
                var fourthCountVar = agy_totals_postgrad.filter(x => x.agy == fourthAgency.split("(")[0].trim() && x.occ == "Post Graduate Researcher")[0];
                var fourthCount = (fourthCountVar !== undefined) ? fourthCountVar.count : 0;

                var firstPercentageVar = agy_totals_postgrad.filter(x => x.agy == firstAgency.split("(")[0].trim() && x.occ == "Post Graduate Researcher")[0];
                var firstPercentage = firstPercentageVar !== undefined ? firstPercentageVar.percentage : 0;
                var secondPercentageVar = agy_totals_postgrad.filter(x => x.agy == secondAgency.split("(")[0].trim() && x.occ == "Post Graduate Researcher")[0];
                var secondPercentage = secondPercentageVar !== undefined ? secondPercentageVar.percentage : 0;
                var thirdPercentageVar = agy_totals_postgrad.filter(x => x.agy == thirdAgency.split("(")[0].trim() && x.occ == "Post Graduate Researcher")[0];
                var thirdPercentage = thirdPercentageVar !== undefined ? thirdPercentageVar.percentage: 0;
                var fourthPercentageVar = agy_totals_postgrad.filter(x => x.agy == fourthAgency.split("(")[0].trim() && x.occ == "Post Graduate Researcher")[0];
                var fourthPercentage = fourthPercentageVar !== undefined ? fourthPercentageVar.percentage : 0;

                secondParagraph = `Post graduate researchers comprised ${(firstPercentage * 100).toFixed(1)}% (${numberWithCommas(firstCount)})${secondCount == "0" ? "" : ", " + (secondPercentage * 100).toFixed(1) + "% (" + numberWithCommas(secondCount) + ")"}${thirdCount == "0" ? "" : ", " + (thirdPercentage * 100).toFixed(1) + "% (" + numberWithCommas(thirdCount) + ")"}${fourthCount == "0" ? "" : ", and " + (fourthPercentage * 100).toFixed(1) + "% (" + numberWithCommas(fourthCount) + ")"} of the employees on awards from ${firstAgency}${secondCount == "0" ? "" : ", " + secondAgency}${thirdCount == "0" ? "" : ", " + thirdAgency}${fourthCount == "0" ? "" : " and " + fourthAgency + ", respectively"}.`;

            }
        }

        //UIUC has no post grad totals, the second paragraph needs a height to keep the chart below the zoom controls.
        var chart_text = `<p>${firstParagraph}</p>`;

        if (common.display_id == 10151) {
            chart_text = `<p>${firstParagraph}</p><br/><br/>`;
        } else {
            chart_text = `<p>${firstParagraph}</p><p>${(secondParagraph === undefined) ? "" : secondParagraph}</p>`;
        }
        if (agg == 0) {
            let text: SpendingReport_Tab1 = { chart2_text: chart_text };
            dispatch({ type: "SPENDING_TAB1_CHART2", payload: text });
        } else {
            let text_agg: SpendingReport_AggTab = { chart2_text: chart_text };
            dispatch({ type: "SPENDING_AGGTAB_CHART2", payload: text_agg });
        }
    }
}
export function setEmployeeChartText(json, common, agg, agg_schools) {
    return dispatch => {
        var data = formatEmployeeChart(json);
        if (agg == 0)
            dispatch({ type: "SPENDING_TAB1_CHART1_DATA", payload: data });
        else
            dispatch({ type: "SPENDING_AGGTAB_CHART1_DATA", payload: data });

        var years = getYears(data[0]);
        if (agg == 0)
            dispatch({ type: "SPENDING_TAB1_CHART1_YEARS", payload: years });
        else
            dispatch({ type: "SPENDING_AGGTAB_CHART1_YEARS", payload: years });

        let total = 0;
        let total_student = 0;
        let total_faculty = 0;

        data.map((item) => {
            var years = Object.keys(item).filter((x) => { return (x.length == 4) });
            years.forEach((year) => {
                total += item[year];

                if (item.occ == "Faculty") {
                    total_faculty += item[year];
                } else if ((item.occ == "Graduate Student") || (item.occ == "Undergraduate") || (item.occ == "Other Student")) {
                    total_student += item[year];
                }
            });
        });

        let student_body = "students";

        let yearly_average = numberWithCommas(Math.round(total / years.length));
        let students_percent = ((total_student / total) * 100).toFixed(1);
        let faculty_percent = ((total_faculty / total) * 100).toFixed(1);

        var yearly_text = (common.startYear_endYear.start_year == common.startYear_endYear.end_year) ? "" : " a yearly";
        var every_year = (common.startYear_endYear.start_year == common.startYear_endYear.end_year) ? "" : "every year";
        const avgMidSententce = common.startYear_endYear.start_year != common.startYear_endYear.end_year ? " average of" : "";
        const avgStartSententce = common.startYear_endYear.start_year != common.startYear_endYear.end_year ? "On average, " : "";

        if (agg == 0) {
            let chart1_text = "";
            if (isAgg(common.display_id)) {//aggregate report
                chart1_text = `<p>During ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))}, ${common.reportType} research expenditures supported${yearly_text}${avgMidSententce} ${yearly_average} individuals ${common.display_id == "999005" ? "on" : "at"} ${aggUniversityAlternateName_AnotherCase(common.university)}.</p>`;
                chart1_text+=`<p>${avgStartSententce}${students_percent}% of individuals supported by ${common.reportType} research funding at these universities ${every_year} were ${student_body}, while ${faculty_percent}% were faculty.</p>`;
            } else if (common.display_id == 23790) {
                chart1_text = `<p>During ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))}, ${common.reportType} research expenditures supported${yearly_text}${avgMidSententce} ${yearly_average} individuals at ${common.university}.</p><p>${avgStartSententce}${faculty_percent}% of individuals supported by ${common.reportType} research funding were faculty.</p>`;
            } else {
                chart1_text = `<p>During ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))}, ${common.reportType} research expenditures supported${yearly_text}${avgMidSententce} ${yearly_average} individuals at ${common.university}.</p><p>${avgStartSententce}${students_percent}% of individuals supported by ${common.reportType} research funding ${every_year} were ${student_body}, while ${faculty_percent}% were faculty. The student figure includes undergraduates, graduate students, and those whose status was unclear in the data ("Other Student").</p>`;
            }
            let text: SpendingReport_Tab1 = { chart1_text: chart1_text };
            dispatch({ type: "SPENDING_TAB1_CHART1", payload: text });
        } else {
            let chart1_text_agg = `<p>During FY ${common.bench_year}, ${common.reportType} research expenditures supported ${yearly_text} average of ${yearly_average} individuals at ${agg_schools.length} IRIS member universities.</p><p>On average, ${students_percent}% of individuals supported by ${common.reportType} research funding ${every_year} were ${student_body}, while ${faculty_percent}% were faculty. The student figure includes undergraduates, graduate students, and those whose status was unclear in the data ("Other Student").</p>`;

            let text_agg: SpendingReport_AggTab = { chart1_text: chart1_text_agg };
            dispatch({ type: "SPENDING_AGGTAB_CHART1", payload: text_agg });
        }
    }
}

export function setExpenditureNationalText(json, spending_total_by_fips, common, agg, mapped_text, agg_schools) {
    return dispatch => {
        if (agg == 0) {
            var text_chart3_total_expenditure, text_chart3_num_county;
            var total_byfips = spending_total_by_fips;

            text_chart3_total_expenditure = total_byfips.filter(y => y.tablename == "all").map(x => x.total).reduce((prev, next) => +prev + +next);
            text_chart3_total_expenditure = numberFormatDown(text_chart3_total_expenditure);
            let only_fips_codes = json.map(x => x.fips)
            let unique_fips_codes = [...new Set(only_fips_codes)];
            text_chart3_num_county = unique_fips_codes.length;

            let chart_text = `<p>The production of science requires the purchase of scientific equipment and technology as well as collaboration with private / public research organizations.</p><p><span>${common.university.charAt(0).toUpperCase() + common.university.slice(1)}${common.university.endsWith("s") ? "'" : "'s"}</span> ${common.reportType} research-related goods and services expenditures exceeded ${text_chart3_total_expenditure} during ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))} and included transactions with vendors in ${text_chart3_num_county} US counties.</p>`;

            //chart 4
            let text4_title = `Vendor and subaward expenditures on ${common.reportType} research awards to ${common.university} by ${common.state_name} counties (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})*`;

            var text_chart4_in_state_total, text_chart4_max_county, text_chart4_max_expenditure;

            let in_state_only = json.filter(x => x.tablename == "all" && x.statecode === common.state_fips);
            const inStateSpendingGroupByCounty = in_state_only.reduce((accu, curr) => {
                accu[curr.fips] = accu[curr.fips] || [];
                accu[curr.fips].push(curr);
                return accu;
            }, {});
            text_chart4_in_state_total = numberFormatDown(
                Object.values(inStateSpendingGroupByCounty).reduce((accu, curr) => {
                    return accu + curr[0].total
                }, 0)
            );
            let sorted_list = in_state_only.sort(function (a, b) { return (a.total > b.total) ? 1 : ((b.total > a.total) ? -1 : 0); });
            //for non-state aggregation calculate highest spending of county
            let all_states = json.filter(x => x.tablename == "all" && x.fips != 0).sort(function (a, b) { return a.total > b.total ? -1 : 1 });
            
            const highest_county = all_states[0].countyname;
            const highest_state = all_states[0].statename;
            const highest_county_spending = numberFormatDown(all_states[0].total);

            text_chart4_max_county = sorted_list[sorted_list.length - 1]["countyname"];
            text_chart4_max_expenditure = numberFormatDown(sorted_list[sorted_list.length - 1]["total"]);
            let chart4_text = `<p>During ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))}, ${common.university}'s ${common.reportType} research generated over ${text_chart4_in_state_total} in expenditures on research-related goods and services in ${common.state_name}.</p>`;
            chart4_text+=`<p>Vendors in ${text_chart4_max_county} County received ${text_chart4_max_expenditure} in purchases, the highest amount in the state.</p>`;

            //for aggregate report
            if (isAgg(common.display_id)) {
                const name = common.state_fips ? `${common.state_name} universities’` : `${common.university}'`;
                text4_title = `Vendor and subaward expenditures on ${common.reportType} research awards to ${aggUniversityAlternateName_AnotherCase(common.university)} by ${common.state_name} county (${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))})*`;
                chart4_text = `<p>During ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))}, ${aggUniversityAlternateName_LowerCase(common.university)} federal and non-federal research generated over ${text_chart4_in_state_total} in expenditures in ${common.state_name}.</p>`;
                chart4_text+=`<p>Purchases from contractors in ${text_chart4_max_county} County exceeded ${text_chart4_max_expenditure}, making it the top-ranking county in the state.</p>`;
                chart_text = `<p>The production of science requires the purchase of scientific equipment and technology as well as collaboration with private/public research organizations.</p>`;
                chart_text += `<p>Research-related spending from ${common.reportType} grants to ${aggUniversityAlternateName_AnotherCase(common.university)} exceeded ${text_chart3_total_expenditure} during ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))} and included transactions with vendors in ${text_chart3_num_county} US counties.</p>`;
                if (!common.state_fips) {
                    chart_text += `<p>Vendor and subaward spending in ${highest_county} County, ${highest_state} exceeded ${highest_county_spending}, making it the highest-ranking county in the U.S.</p>`;   //non-state level aggregation combine chart 3 and 4     
                }
            }

            let text: SpendingReport_Tab1 = { chart3_text: chart_text };
            dispatch({ type: "SPENDING_TAB1_CHART3", payload: text });

            let text4: SpendingReport_Tab1 = { chart4_chart_title: text4_title, chart4_text: chart4_text };
            dispatch({ type: "SPENDING_TAB1_CHART4", payload: text4 });

            dispatch({ type: "SPENDING_TAB1_FOOTER", payload: mapped_text });
        } else {
            var text_chart3_total_expenditure, text_chart3_num_county;
            var totals = json.filter(y => y.tablename == "all" && y.rank == "1").map(x => x.total);
            if (totals.length > 0) {
                text_chart3_total_expenditure = totals.reduce((prev, next) => +prev + +next);
                text_chart3_total_expenditure = numberFormatDown(text_chart3_total_expenditure);
            }
            let only_fips_codes = json.map(x => x.fips)
            let unique_fips_codes = [...new Set(only_fips_codes)];
            text_chart3_num_county = unique_fips_codes.length;
            let chart_text = `<p>The production of science requires the purchase of scientific equipment and technology as well as collaboration with private/public research organizations.</p><p>Research expenditures at these ${agg_schools.length} IRIS member universities exceeded ${text_chart3_total_expenditure} during ${"FY " + common.bench_year} and included transactions with vendors in ${numberWithCommas(text_chart3_num_county)} US counties.</p>`;         
            var agg_text: SpendingReport_AggTab = { chart3_text: chart_text };
            dispatch({ type: "SPENDING_AGGTAB_CHART3", payload: agg_text });
        }
    }
}


export function setCongressText(json, states_list, spending_total_by_fips, common, mapped_text) {
    const agg = isAgg(common.display_id);//check if it's aggregate report
    const stateLevel = common.state_fips;
    const name = agg && stateLevel ? `${common.state_name} Universities` : common.university;
    return dispatch => {

        var text_chart3_total_expenditure;
        var total_byfips = spending_total_by_fips;

        text_chart3_total_expenditure = total_byfips.filter(y => y.tablename == "all").map(x => x.total).reduce((prev, next) => +prev + +next);
        text_chart3_total_expenditure = numberFormatDown(text_chart3_total_expenditure);

        var congress_ids = json.filter(x => x.payment_amt).map(x => x.congress_id);
        var congressional_count = ([...new Set(congress_ids)]).length;        
        var washington = congress_ids.map(x => x.padStart(4, '0').substring(0,2)).includes("53") ? " (includes Washington, D.C.)" : "";

        let chart1_text = `<p><span>${common.university && common.university.charAt(0).toUpperCase() + common.university.slice(1)}${common.university.endsWith("s") ? "'" : "'s"}</span> ${common.reportType} research expenditures on research-related goods and services exceeded ${text_chart3_total_expenditure} during ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))} and included transactions with vendors in ${congressional_count} US congressional districts${washington}.</p>`;

        let in_state_only = total_byfips.filter(x => { return (x.tablename == "all" && x['statecode'] == common.state_fips); });
        var text_chart4_in_state_total = numberFormatDown(in_state_only.map(x => x.total).reduce((prev, next) => +prev + +next));

        var district_count, district_total, district_name;
        var state_code = padWithTwoLeadingZeros(common.state_fips);

        var congress_data_in_state_only = json.filter(x => {
            var zeid = padWithFourLeadingZeros(x.congress_id) //pad with leading 0
            return (zeid.substr(0, 2) == state_code);
        });

        let sorted_list = congress_data_in_state_only.sort(function (a, b) { return (a.payment_amt > b.payment_amt) ? 1 : ((b.payment_amt > a.payment_amt) ? -1 : 0); });
        var highest_district = sorted_list[sorted_list.length - 1];

        //for non-state aggregation calculate highest spending of congress district
        const congress_data_all_state = json.filter(x => { return x.tablename == "all" }).sort((a, b) => { return a.payment_amt > b.payment_amt? -1 : 1});
        const highest_district_all = getOrdinal(trimLeadingZero(padWithFourLeadingZeros(congress_data_all_state[0].congress_id).substr(2, 2)));
        const highest_district_total = numberFormatDown(congress_data_all_state[0].payment_amt);
        const highest_state = states_list ? states_list.filter((state) => { return congress_data_all_state[0].congress_id.substr(0, 2) == state.statecode }) : [];
        const highest_state_name = (highest_state && highest_state.length > 0) ? highest_state[0].statename : null;

        district_total =highest_district?  billionNumberFormatDown(highest_district.payment_amt) : 0;
        district_name =highest_district? getOrdinal(trimLeadingZero(padWithFourLeadingZeros(highest_district.congress_id).substr(2, 2))): "";

        let unique_list = ([...new Set(sorted_list.filter(x => x.payment_amt).map(x => x.congress_id))]);
        district_count = unique_list.length;


        let chart2_text = `<p>During ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))}, ${common.university}'s ${common.reportType} research generated over ${text_chart4_in_state_total} in expenditures on research-related goods and services in ${district_count} ${common.state_name} congressional districts.</p>`;
            chart2_text+=`<p>Purchases from vendors in the ${district_name} congressional district exceeded ${district_total}, the highest of any congressional district in the state.</p>`;
        if (agg) {
            chart1_text = `<p>Research-related spending on goods and services from ${common.reportType} grants to ${aggUniversityAlternateName_AnotherCase(common.university)} exceeded ${text_chart3_total_expenditure} during ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))} and included transactions with vendors in ${congressional_count} US congressional districts${washington}.</p>`;
            if (!stateLevel) {
                //combined 2 maps and add a paragraph
                chart1_text += `<p>Purchases from vendors in ${highest_state_name}’s ${highest_district_all} congressional district exceeded ${highest_district_total}, making it the top-ranking district in the U.S.</p>`;
            }
            chart2_text = `<p>During ${formatFiscalYear(getYearRangeLabel(common.startYear_endYear))}, ${aggUniversityAlternateName_LowerCase(common.university)} ${common.reportType} research generated over ${text_chart4_in_state_total} in expenditures on research-related goods and services in ${common.state_name} congressional districts.</p>`;
            chart2_text+=`<p>Purchases from vendors in ${common.state_name}’s ${district_name} congressional district exceeded ${district_total}, making it the top-ranking district in the state.</p>`;
        }

        var text: SpendingReport_Tab1 = { chart1_text: chart1_text, chart2_text: chart2_text };
        dispatch({ type: "SPENDING_TAB2_CHART1", payload: text });


        dispatch({ type: "SPENDING_TAB2_FOOTER", payload: mapped_text });

    }
}
